/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type PdpSharedDetailItemInvoice_user = {
    readonly profile: {
        readonly email: string | null;
    } | null;
    readonly " $refType": "PdpSharedDetailItemInvoice_user";
};
export type PdpSharedDetailItemInvoice_user$data = PdpSharedDetailItemInvoice_user;
export type PdpSharedDetailItemInvoice_user$key = {
    readonly " $data"?: PdpSharedDetailItemInvoice_user$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedDetailItemInvoice_user">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedDetailItemInvoice_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Profile",
      "kind": "LinkedField",
      "name": "profile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "email",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};
(node as any).hash = '93dd0139e24f5d53c02ad4ca197e0255';
export default node;
